import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import { environment } from 'environments/environment.prod';
import { InvoicePdfOptions } from '../../sales/invoice-list/Print/invoice-pdf-options.interface';

@Injectable({
    providedIn: 'root'
})
export class CollectionService {
    private readonly baseUrl = environment.API_DOCUMENT_EXPORT_URL + 'order-payment-pdf/payment/';
    
    constructor(private http: HttpClient) { }
    
    downloadAndSaveCollection(collectionId: string, options?: InvoicePdfOptions): Observable<void> {
        let params = new HttpParams();
        if (options) {
            Object.entries(options).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                    params = params.set(key, String(value));
                }
            });
        }
        return this.http.get(`${this.baseUrl}${collectionId}`, {
            params,
            responseType: 'blob'
        }).pipe(
            tap((blob: Blob) => {
                const fileName = this.generateFileName(collectionId);
                saveAs(blob, fileName);
            }),
            tap(() => { })
        ) as Observable<void>;
    }
   
    private generateFileName(collectionId: string): string {
        const date = new Date().toISOString().split('T')[0];
        return `Cobranza_${collectionId}_${date}.pdf`;
    }
}